export interface AirdropResult {
  participate: boolean; // 是否参与
  sybil: boolean; // 是否合规
  shouldAirdrop: number; // 空投数量
}
// 这两个时间中间显示计算中
export const endTime = '2024-12-22 23:59:59'; // 活动结束时间
export const airdropStartTime = '2024-12-27 00:00:00'; // 空投开始时间
// export const endTime = '2024-12-21 14:00:00'; // 活动结束时间
// export const airdropStartTime = '2024-12-24 17:25:00'; // 空投开始时间
